<template>
  <div>
    <el-dialog
      title="费用结算已升级"
      class="toNewSettlementDialog"
      :visible.sync="dialogVisible"
      width="55%"
      :center="true"
      :destroy-on-close="false"
      :modal="true"
    >
      <div>
        <p class="text-center text-sm text-gray-800">一键结算面对面访问、电话调查、明察暗访的调查员、代理费用</p>
        <p class="text-center text-sm text-gray-800 mb-8">
          开通费用结算后，您可使用线上结算服务，<span v-custom="'out_D74'">调研工厂</span>将按调查员到手金额的
          {{ isOpenAccountingCost ? '6.5%～7.5%' : accountingRate + '%' }}
          收取费用{{ isOpenAccountingCost ? '【具体服务费费率请与客服联系】': '' }} ，用于调查员代缴税及平台技术服务费。同时，为您的总花费金额开具 6%
          的增值税专用发票或普通发票。
        </p>
        <img class="w-full" src="/assets/img/settlement/protocol-intro.png" />
      </div>
      <span slot="footer">
        <el-button type="primary" @click="newVersion">去使用新版</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ToNewSettlementDialog',
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    accountingRate() {
      return this.$store.getters.accountingRate
    },
    isOpenAccountingCost() {
      return this.accountingRate === null || this.accountingRate === 0
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    newVersion() {
      this.$router.push({ name: 'cost-settlement' })
    }
  }
}
</script>

<style lang="scss">
.toNewSettlementDialog {
  .el-dialog__header {
    display: block;
    .el-dialog__headerbtn {
      float: right;
    }
  }
}
</style>
